
import React, { useState, useEffect } from 'react'
import { CommunityLeadGetUserApi, CommunityLeadGetUserLoanApi, getActivityApi,getCommunityPersonalApi } from '../../CommunityActionCreator';
import CloseIcon from '@mui/icons-material/Close';
import { Tooltip } from '@mui/material';

// let rolesData = window.sessionStorage.getItem('rolesData');

const ViewLeadsInfoPopup = ({ data, actionhandler }) => {

    const [viewScreen, setViewScreen] = useState('detail')
    const [activityData, setactivityData] = useState('')

    const [personalData, setPersonalData] = useState({})
    const [objectData, setObjectData] = useState({})
    const [loanData, setLoanData] = useState({})
    const [communityData, setCommunityData] = useState({})

    useEffect(() => {

        getActivityApi(data.loanId, callBack => {
            setactivityData(callBack)
        }, error => {

        })
        console.log(data, "SENDING DATAAA");
        getLoanData(data.loanId)
        getPersonalDetail()
        getCommunityByCommunityId()
    }, [])


    const getPersonalDetail = () => {
        CommunityLeadGetUserApi(data.userId,
            callBack => {
                if (Object.keys(callBack).length > 0) {
                    let changeObjectData = Object.assign({}, objectData)
                    Object.keys(callBack).forEach(key => {
                        changeObjectData[key] = callBack[key]
                    })

                    setObjectData(changeObjectData)
                    setPersonalData(changeObjectData)
                    CommunityLeadGetUserLoanApi(data.loanId,
                        callBack => {
                            console.log(callBack.sourceOfIncome, 'callBack.sourceOfIncome')
                                (callBack.sourceOfIncome)

                        })
                }
            }, error => {

            })
    }


    const leadPageHandler = (e) => {
        setViewScreen(e)
    }

    const getLoanData = (loanId) => {
        CommunityLeadGetUserLoanApi(loanId, callBack => {
            setLoanData(callBack)
        }, error => {

        })
    }
    const getCommunityByCommunityId = () => {
        getCommunityPersonalApi(data.communityId, callBack => {
            setCommunityData(callBack)
        })
    }

    return (
        <div className="background-blur-external" style={{ zIndex: '9999' }}>
            <div className='delete-popup-main' style={{ minHeight: '600px', minWidth: '600px' ,top:'13%'}}>
                <Tooltip title='Close'>
                    <CloseIcon onClick={(e) => actionhandler('close')} style={{ marginBottom: '20px', color: '#000', cursor: 'pointer' }} />
                </Tooltip>
                <div className='row'>
                    <div className="edit-profile-menu col-xs-12">
                        <div className="btn-group-tab">
                            <div>
                                <button className={viewScreen === 'detail' ? 'active' : ''} onClick={e => leadPageHandler('detail')}>Details</button>
                            </div>
                            <div>
                                <button className={viewScreen === 'activity' ? 'active' : ''} onClick={e => leadPageHandler('activity')}>Activity </button>
                            </div>
                        </div>
                    </div>

                    <div className='row' >
                        <div className='col-sm-12 col-xs-12 mt-2'>

                            {viewScreen === 'detail' ?
                                <div className='row'>
                                    <div className="col-sm-12 col-xs-12">
                                        <div className="profile-details-box-new" style={{ minHeight: '420px' }}>
                                            <div style={{ padding: '10px' }}>
                                                {
                                                    communityData && communityData.id > 0 ? "" : <h3>B2C Lead</h3>
                                                }
                                                <h4>Personal Info</h4>
                                                <div className='row' >
                                                    <div className='col-sm-2 col-xs-12'>
                                                        <label className='' style={{ fontSize: '14px' }}>Name</label>
                                                    </div>
                                                    <div className='col-sm-4 col-xs-12'>
                                                        <div style={{ fontSize: '14px' }}> <b>{personalData.name}</b></div>
                                                    </div>
                                                    <div className='col-sm-2 col-xs-12'>
                                                        <label className='' style={{ fontSize: '14px' }}>Mobile No
                                                        </label>
                                                    </div>
                                                    <div className='col-sm-4 col-xs-12'>
                                                        <div style={{ fontSize: '14px' }}> <b>{personalData.mobileNo}</b></div>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='col-sm-2 col-xs-12'>
                                                        <label className='' style={{ fontSize: '14px' }}>Email Id
                                                        </label>
                                                    </div>
                                                    <div className='col-sm-4 col-xs-12'>

                                                        <div style={{ fontSize: '14px' }}> <b>{personalData.emailId}</b></div>
                                                    </div>
                                                </div>

                                            </div>
                                            {
                                                communityData && communityData.id > 0?
                                                <div style={{ padding: '10px' }}>
                                                    <h4>Community Details</h4>
                                                    <div className='row' >
                                                        <div className='col-sm-2 col-xs-12'>
                                                            <label className='' style={{ fontSize: '14px' }}>Community Name</label>
                                                        </div>
                                                        <div className='col-sm-4 col-xs-12'>
                                                            <div style={{ fontSize: '14px' }}> <b>{communityData.name}</b></div>
                                                        </div>
                                                        <div className='col-sm-2 col-xs-12'>
                                                            <label className='' style={{ fontSize: '14px' }}>Community Mobile No
                                                            </label>
                                                        </div>
                                                        <div className='col-sm-4 col-xs-12'>
                                                            <div style={{ fontSize: '14px' }}> <b>{communityData.mobileNo}</b></div>
                                                        </div>
                                                    </div>
                                                    <div className='row'>
                                                        <div className='col-sm-2 col-xs-12'>
                                                            <label className='' style={{ fontSize: '14px' }}>Community Email Id
                                                            </label>
                                                        </div>
                                                        <div className='col-sm-4 col-xs-12'>

                                                            <div style={{ fontSize: '14px' }}> <b>{communityData.email}</b></div>
                                                        </div>
                                                    </div>

                                                </div>
                                            :""}
                                            <div style={{ padding: '10px' }}>
                                                <h4>Loan Details</h4>
                                                <div className='row' >
                                                    <div className='col-sm-2 col-xs-12'>
                                                        <label className='' style={{ fontSize: '14px' }}>Loan Amount</label>
                                                    </div>
                                                    <div className='col-sm-4 col-xs-12'>
                                                        <div style={{ fontSize: '14px' }}> <b>{loanData.loanAmount}</b></div>
                                                    </div>
                                                    <div className='col-sm-2 col-xs-12'>
                                                        <label className='' style={{ fontSize: '14px' }}>Tenure
                                                        </label>
                                                    </div>
                                                    <div className='col-sm-4 col-xs-12'>
                                                        <div style={{ fontSize: '14px' }}> <b>{loanData.tenurePeriod}</b></div>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='col-sm-2 col-xs-12'>
                                                        <label className='' style={{ fontSize: '14px' }}>Source Of Income
                                                        </label>
                                                    </div>
                                                    <div className='col-sm-4 col-xs-12'>
                                                        <div style={{ fontSize: '14px' }}> <b>{loanData.sourceOfIncome}</b></div>
                                                    </div>
                                                    <div className='col-sm-2 col-xs-12'>
                                                        <label className='' style={{ fontSize: '14px' }}>Loan Type
                                                        </label>
                                                    </div>
                                                    <div className='col-sm-4 col-xs-12'>
                                                        <div style={{ fontSize: '14px' }}> <b>{loanData.loanType}</b></div>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>



                                : viewScreen === 'activity' ?
                                    <div className='container-fluid full-height'>
                                        {activityData && activityData.map((row, i) => {
                                            return (
                                                <div key={i}>
                                                    <div className='row'>
                                                        {console.log(activityData.length, 'row.length')}
                                                        <div className='col-sm-2 col-xs-12'>
                                                            <div className='activity-circle text-center'>
                                                                <div style={{ marginTop: '-4px' }}> {i + 1}</div>
                                                            </div>
                                                            {i + 1 < activityData.length ?
                                                                <div style={{ background: '#000', width: '5px', marginLeft: 'auto', marginRight: 'auto', height: '30px', marginTop: '10px' }}></div>
                                                                : <div><div style={{ background: '#bcb4b4', width: '5px', marginLeft: 'auto', marginRight: 'auto', height: '30px', marginTop: '10px' }}></div>
                                                                    <div className='activity-circle text-center' style={{ background: '#bcb4b4' }}>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                        <div className='col-sm-10 col-xs-12 text-left'>
                                                            <h6 className='mt-3'> <b>{row.status} </b></h6>
                                                            <p className='mb-0' style={{ color: '#7681a2' }}>{row.employeeId}</p>

                                                          <b className='' style={{color:'#182d64'}}>  {row.comment ?
                                            <p className='' style={{color:'#7681a2'}}>{row.comment}</p>
                                            : ""}</b>
                                                            <p className='mb-0' style={{ color: '#7681a2' }}>{row.date}</p>

                                                        </div>
                                                    </div>
                                                </div>

                                            )
                                        })}
                                        {/* <div className='row mt-3'>

                                            <div style={{ overflowX: 'auto' }}>
                                                <table className='table credhub-table'>
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">Date</th>
                                                            <th scope="col">Status</th>

                                                            <th scope="col">Employee Id</th>
                                                            <th scope="col">Action</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            activityData && activityData.length > 0 ?
                                                                activityData.map((row, i) => {
                                                                    return (
                                                                        <tr key={i}>

                                                                            <td>{row.date}</td>
                                                                            <td>{row.status}</td>

                                                                            <td>{row.employeeId}</td>
                                                                            <td>{row.comment}</td>

                                                                        </tr>
                                                                    )
                                                                }) : <h4>No Activity Found!!</h4>}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div> */}
                                    </div>

                                    : null}
                        </div>

                    </div>
                </div>
            </div>

        </div>
    )
}

export default ViewLeadsInfoPopup;